import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { _programid } from '../RecoilState';
import axios from 'axios';
import Loader from '../components/Loader';
import GutenContent from '../components/GutenContent';
import '../components/components.css';
import "@wordpress/block-library/build-style/common.css";
import "@wordpress/block-library/build-style/style.css";
import "@wordpress/block-library/build-style/theme.css";

const CorporateOfferings = () => {
    const { cslug } = useParams(); // Access the parameter as 'pageSlug'
    // const [programid, setProgramid] = useRecoilState(_programid);
    const [loading, setLoading] = useState(true);
    const [programdetails, setProgramdetails] = useState({})
    const [gutenbergcontent, setGutenbergcontent] = useState("");
    const [pagehead, setPagehead] = useState("")

    useEffect(() => {
        // console.log(cslug)
        // console.log(programid);
        getProgramdata()
    }, [])

    const getProgramdata = () => {
        axios.get(`/pages?slug=${cslug}`)
            // axios.get(`/programs/74`)
            .then((response) => {
                setPagehead(response.data[0].title.rendered)
                setProgramdetails(response.data[0])
                setGutenbergcontent(response.data[0].content.rendered)
                setLoading(false)
            })
    }

    return (
        <div>
            {
                loading ? <Loader /> :
                    <div className='bottom15px'>
                        <div className='spacer'>
                            <p className='brand-text large-gradient-heading'>{pagehead}</p>
                        </div>
                        <GutenContent htmldata={gutenbergcontent} />
                    </div>
            }
        </div>
    )
}

export default CorporateOfferings